/**
 * @file paddle hack light
 * @author wanzhongyun
 */
import { RootObject, Content } from '../../type';

import './style.less';


const HackLight = (props: RootObject["eventHighlights"]) => {

    const {
        titleImg,
        content,
        subTitle
    } = props;



    return (
        <div className='paddle-hack-light-f-wrapper'>
            <div className="paddle-hack-light-f-content">
                <img className='paddle-hack-light-f-title' src={titleImg} alt='' />
                <div className='paddle-hack-light-f-sub-title'>{subTitle ?? ''}</div>
                <div
                    className="paddle-hack-light-f-list"
                >
                    {
                        content?.map((value: Content, index: number) => {
                            return (
                                <div className="paddle-hack-light-f-list-content" key={index}>
                                    <div
                                        className="content-wrapper"
                                    >
                                        <div
                                            className="content-title"
                                        >
                                            {value.title ?? ""}
                                        </div>
                                        <div
                                            className="content-describe"
                                        >
                                            {value.describe ?? ""}
                                        </div>
                                    </div>
                                    <div
                                        className="content-Img"
                                        style={{ backgroundImage: `url(${value.img})` }}
                                    >

                                    </div>
                                </div>
                            )
                        })
                    }

                </div>

            </div>


        </div>
    );
};

export default HackLight;